<div class="p-grid table-demo ">
    <div class="p-col-12">
        <p-toast key="toastmsg"></p-toast>
        <div class="card">
            <h3>Ranking History</h3>

            <section class="body-section">
                <div class="container-fluid p-p-0">
                    <main>
                        <div class="bottom-container Transaction-table ">
                            <div class="box transaction-box Rankinghistory">
                               
                                <p-table #dt [value]="rankingList" dataKey="rank" [paginator]="true" [rows]="10" [lazy]="true"
                                    [scrollable]="true" scrollHeight="auto" scrollDirection="both"
                                    (onLazyLoad)="loadRanking($event)" [totalRecords]="totalRecords" [loading]="loading"
                                    [rowsPerPageOptions]="paginationOption" [value]="rankingList" responsiveLayout="scroll">
                                    <ng-template pTemplate="header">
                                        <tr>
                                            <th style="width: 0; min-width: 0px;" class="icons"></th>
                                            <th class="rank">Rank </th>
                                            <th class="tournamentName">Tournament Name</th>
                                            <th class="MatchType">Match-Type</th>
                                            <th class="AgeGroup">Age Group </th>
                                            <th class="Points">Points </th>
                                            <th class="button-table"> </th>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="body" let-rank let-expanded="expanded">
                                        <tr>
                                            <td class="icons">
                                                <button type="button" pButton pRipple [pRowToggler]="rank"
                                                    class="p-button-text p-button-rounded p-button-plain"
                                                    [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
                                            </td>
                                            <td class="rank">
                                                {{rank.rank}}
                                            </td>
                                            <td class="tournamentName">
                                                {{rank.tournamentName}}
                                            </td>
                                            <td class="MatchType">
                                                {{rank.categoryName}}
                                            </td>
                                            <td class="AgeGroup">
                                                {{rank.agegroupName}}
                                            </td>
                                            <td class="Points">
                                                {{rank.playerRanking}}
                                            </td>
                                            <td class="button-table">
                                                <button pButton [pRowToggler]="rank"
                                                    class="p-button-text p-button-rounded p-button-plain show-btn">Show
                                                    Details</button>
                                            </td>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="rowexpansion" let-rank>
                                        <tr dataKey="id">
            
                                            <td colspan="10">
                                                <div class="accordian-body " id="compare-1">
                                                    <div class="compare-table-inner-div">
                                                        <!-- <div class="close-inner-icon">
                                                            <button data-bs-toggle="collapse" data-bs-target="#compare-1"> <i
                                                                    class="pi pi-times"></i></button>
                                                        </div> -->
                                                        <div class="rin-player-ranks-table-container">
                                                            <div class="rin-current-year-ranks">
                                                                <div class="rin-ranks-header">{{currentYear | date:'yyyy'}}</div>
                                                                <div class="rin-current-year-data">
                                                                    <div class="rin-ranks-data"><span>{{rank.rank}}</span>
                                                                        <span>Current
                                                                            Ranking</span>
                                                                    </div>
                                                                    <div class="rin-ranks-data"><span>
                                                                            {{highestRankNumber}}
                                                                        </span>
                                                                        <span>Highest
                                                                            Ranking</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="rin-career-ranks">
                                                                <div class="rin-ranks-header">Career</div>
                                                                <div class="rin-ranks-data"><span>{{highestRankNumber}}</span>
                                                                    <span>{{highestRankNumberCreatedAt|date:'dd-MM-yyyy'}}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
            
                                                </div>
                                            </td>
                                        </tr>
                                    </ng-template>
                                </p-table>
            
                            </div>
                        </div>
                      
                    </main>
                </div>
            </section>
        </div>

        <div class="card">
           
            <section class="body-section">
                <div class="container-fluid p-p-0">
                    <main>
                     
                        <div class="bottom-container Transaction-table ">
                            <div class="box transaction-box ">
                                <div class="header-container">
                                    <h3 class="section-header p-mt-0">Ranking Movement
                                    </h3>
                                </div>
                                <div class="chart border-div">
                                    <p-dropdown inputId="yearOptions" [ngModel]="selectedYear" [options]="yearOptions"
                                        (onChange)="onClickYear($event)" placeholder="Select year" optionLabel="year"
                                        [filter]="true"></p-dropdown>
                                    <p-chart type="line" [data]="rankingData" [options]="basicOptions"></p-chart>
                                </div>
                            </div>
                        </div>
                    </main>
                </div>
            </section>
        </div>
    </div>
</div>


